module.exports = __webpack_public_path__ + "media/components/country-flag/static/bs-9d32a1df72c52f2340238b15bd2db633.svg";